import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AuthGuard } from '../guards/auth.guard';
import { TodoComponent } from './todo.component';
import { MatButtonModule} from '@angular/material/button';
import { CalendarViewModule } from './calendar-view/calendar-view.module';
import { EditCalendarEventDialogModule } from '../components/edit-calendar-event-dialog/edit-calendar-event-dialog.module';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';


@NgModule({
  imports: [
    CommonModule,
    EditCalendarEventDialogModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    CalendarViewModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: 'work-queue',
        canActivate: [AuthGuard],
        component: TodoComponent,
        children: []
      }
    ])
  ],
  declarations: [
    TodoComponent
  ],
  exports: [
    TodoComponent
  ]
})
export class TodoComponentModule { }
